import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../sections/Hero";
import { WhyOnline } from "../sections/WhyOnline";
import { Services } from "../sections/Services";
import { Trust } from "../sections/Trust";
import { Process } from "../sections/Process";
import { Ownership } from "../sections/Ownership";
import { Portfolio } from "../sections/Portfolio";
import { Pricing } from "../sections/Pricing";
import { Faq } from "../sections/Faq";
import { Contact } from "../sections/Contact";
import { scrollToId } from "../lib/scroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash), 80);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <main>
      <Hero />
      <WhyOnline />
      <Services />
      <Trust />
      <Process />
      <Ownership />
      <Portfolio />
      <Pricing />
      <Faq />
      <Contact />
    </main>
  );
}
